import React, { useEffect, useState } from "react";
import { Label } from "../ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { ChevronLeft, ChevronRight } from "lucide-react";

const MONTH_NAMES_RO = ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Noi", "Dec"];
const MONTH_NAMES_RO_LONG = ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"];

export function MonthPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [y, m] = value.split("-").map(Number);
  const [navYear, setNavYear] = useState(y);
  useEffect(() => { setNavYear(y); }, [y]);
  const label = `${MONTH_NAMES_RO_LONG[m - 1]} ${y}`;
  const goPrev = (e) => {
    e.stopPropagation();
    const nm = m === 1 ? 12 : m - 1;
    const ny = m === 1 ? y - 1 : y;
    onChange(`${ny}-${String(nm).padStart(2, "0")}`);
  };
  const goNext = (e) => {
    e.stopPropagation();
    const nm = m === 12 ? 1 : m + 1;
    const ny = m === 12 ? y + 1 : y;
    onChange(`${ny}-${String(nm).padStart(2, "0")}`);
  };
  return (
    <div className="flex items-end gap-1.5">
      <div>
        <Label className="small-label">Luna</Label>
        <div className="flex items-center mt-1">
          <button
            type="button"
            onClick={goPrev}
            className="h-9 w-9 grid place-items-center border border-r-0 border-[var(--border)] rounded-l-md hover:bg-zinc-50"
            data-testid="month-prev"
            title="Luna anterioară"
          ><ChevronLeft size={16}/></button>
          <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
              <button
                type="button"
                data-testid="overview-month"
                className="h-9 px-3 border border-[var(--border)] text-sm font-semibold min-w-[160px] hover:bg-zinc-50"
              >
                {label}
              </button>
            </PopoverTrigger>
            <PopoverContent className="w-64 p-3" align="start">
              <div className="flex items-center justify-between mb-3">
                <button onClick={() => setNavYear(navYear - 1)} className="p-1 hover:bg-zinc-100 rounded" data-testid="picker-year-prev">
                  <ChevronLeft size={16}/>
                </button>
                <span className="font-display text-base font-bold" data-testid="picker-year">{navYear}</span>
                <button onClick={() => setNavYear(navYear + 1)} className="p-1 hover:bg-zinc-100 rounded" data-testid="picker-year-next">
                  <ChevronRight size={16}/>
                </button>
              </div>
              <div className="grid grid-cols-3 gap-1.5">
                {MONTH_NAMES_RO.map((mn, idx) => {
                  const selected = navYear === y && idx + 1 === m;
                  return (
                    <button
                      key={mn}
                      type="button"
                      data-testid={`picker-month-${idx + 1}`}
                      onClick={() => {
                        onChange(`${navYear}-${String(idx + 1).padStart(2, "0")}`);
                        setOpen(false);
                      }}
                      className={`px-2 py-2 text-xs font-semibold rounded-md transition-colors ${
                        selected ? "bg-[var(--primary)] text-white" : "hover:bg-zinc-100 text-zinc-700"
                      }`}
                    >
                      {mn}
                    </button>
                  );
                })}
              </div>
              <button
                onClick={() => {
                  const today = new Date();
                  onChange(`${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`);
                  setOpen(false);
                }}
                className="w-full mt-3 text-[11px] text-[var(--primary)] hover:underline"
                data-testid="picker-today"
              >Mergi la luna curentă</button>
            </PopoverContent>
          </Popover>
          <button
            type="button"
            onClick={goNext}
            className="h-9 w-9 grid place-items-center border border-l-0 border-[var(--border)] rounded-r-md hover:bg-zinc-50"
            data-testid="month-next"
            title="Luna următoare"
          ><ChevronRight size={16}/></button>
        </div>
      </div>
    </div>
  );
}

export { MONTH_NAMES_RO, MONTH_NAMES_RO_LONG };
